import { useQuery } from "@tanstack/react-query";
import giftCategoriesClient from "../../../../api/giftCategories";

const useOrderQuery = (orderName: string) => {
  return useQuery({
    queryKey: ["order", orderName],
    queryFn: async () => giftCategoriesClient.getOrderInfo(orderName),
    enabled: !!orderName,
  });
};
export default useOrderQuery;
